import { z } from "zod";

export const ThemePreference = z.enum(["light", "dark", "system"]);
/** Accent color for actions, selection and focus. Purple is the DevFusion brand; every accent is AA-checked in light and dark. */
export const Accent = z.enum(["purple", "wine", "ocean", "forest", "teal", "slate", "amber"]);
export const Density = z.enum(["comfortable", "cozy", "compact"]);
export const SplitView = z.enum(["none", "right", "bottom"]);
/** "always": load remote images through the Workspace proxy (Gmail default). "ask": hide until "Show images". */
export const ExternalImages = z.enum(["always", "ask"]);

export const UserSettings = z.object({
  theme: ThemePreference.default("system"),
  // catch, not default: an accent removed in a later release must not reset every other setting.
  accent: Accent.catch("purple"),
  density: Density.default("cozy"),
  splitView: SplitView.default("right"),
  sidebarCollapsed: z.boolean().default(false),
  /** Pane sizes in percent, keyed by layout, remembered per user. */
  paneSizes: z.record(z.string(), z.number().min(15).max(85)).default({}),
  undoSendSeconds: z.number().int().min(5).max(30).default(10),
  timezone: z.string().default("Asia/Karachi"),
  shortcutsEnabled: z.boolean().default(true),
  externalImages: ExternalImages.default("always"),
  /** Desktop notifications for chat messages when the conversation is not on screen. */
  chatNotifications: z.boolean().default(true),
  /** What r does and which button is first in a conversation. */
  defaultReply: z.enum(["reply", "replyAll"]).catch("reply"),
  /** Order of messages inside a conversation. */
  threadOrder: z.enum(["oldest", "newest"]).catch("oldest"),
});

export type ThemePreference = z.infer<typeof ThemePreference>;
export type Accent = z.infer<typeof Accent>;
export type Density = z.infer<typeof Density>;
export type SplitView = z.infer<typeof SplitView>;
export type ExternalImages = z.infer<typeof ExternalImages>;
export type UserSettings = z.infer<typeof UserSettings>;

export const defaultSettings: UserSettings = UserSettings.parse({});
